import { colors } from 'Constants/Colors';

export const iconStyle = {
  width: '10%',
  margin: '2rem auto 0 auto',
  display: 'flex',
  justifyContent: 'center',
  background: colors.GREEN_ULTRA_LIGHT,
  color: colors.GREEN,
  padding: '2% .2% 2% .2%',
  fontSize: '2rem',
  borderRadius: '10%',
};

export const titleStyle = {
  width: '80%',
  fontWeight: 'bold',
  margin: 'auto',
  textAlign: 'center',
};

export const textStyle = {
  width: '80%',
  fontWeight: '100',
  margin: 'auto',
  color: colors.GRAY_DARK,
};

export default { iconStyle, titleStyle, textStyle };
